import { CompanyModel } from '@/modules/company/company-model';

const { fields } = CompanyModel;

export default [
  fields.id,

  fields.createdAt
];
